import { PageHeader } from "../components/header/PageHeader";

import ResourcesLinks from "../components/resources/ResourcesLinks";
import ExternalFormsHeader from "./external/header/ExternalFormsHeader";

const ResourcesLinksPage = () => {
  const headerText = [
    {
      class: "p-0 m-0 flex items-center",
      value: "KIS resources",
      icon: " res-header-icon icon-spec",
    },
  ];
  return (
    <>
      <ExternalFormsHeader></ExternalFormsHeader>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>{" "}
      <div className="triangle-image res-triangle">
        <img src={import.meta.env.VITE_LOGIN_BACKGROUND_URL} alt="Background Image" />
      </div>
      <div className="h-screen resource-links-block flex flex-col gap-3">
        <ResourcesLinks
          mainIcon="resource-icon-spec icon-spec kids"
          links={[
            {
              label: "KIS Program – Guidelines for the Disability and Complex Medical Needs streams",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-Program-%E2%80%93-Guidelines-for-the-Disability-and-Complex-Medical-Needs-streams.pdf",

              headerResources: "Program Guidelines",
            },
          ]}
        />
        <ResourcesLinks
          mainIcon="resource-icon-spec icon-spec globe"
          links={[
            {
              label: "KIS Plan",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-plan.pdf",

              headerResources: "Application document templates",
            },
            {
              label: "KIS privacy notice and consent form",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-privacy-notice-and-consent-form.pdf",
            },
          ]}
        />
        <ResourcesLinks
          mainIcon="resource-icon-spec icon-spec kids-book"
          links={[
            {
              label: "Updated KIS application questions",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/Updated-KIS-application-questions.docx",

              headerResources: "Revised application questions",
            },
          ]}
        />
        <ResourcesLinks
          mainIcon="resource-icon-spec icon-spec bus"
          links={[
            {
              label: "Kindergarten information session video",
              url: "https://vimeo.com/1109908575?share=copy#t=0",

              headerResources: "Kindergarten information session",
            },
          ]}
        />
        <ResourcesLinks
          mainIcon="resource-icon-spec icon-spec kid-cert"
          links={[
            {
              label: "KIS factsheet 1 - What's new in KIS",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-factsheet-1-Whats-new-in-KIS.pdf",

              headerResources: "Factsheets",
            },
            {
              label: "KIS factsheet 2 - The purpose of KIS",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-factsheet-2-The-purpose-of-KIS.pdf",
            },
            {
              label: "KIS factsheet 3 – How to set up a PSG",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-factsheet-3-How-to-set-up-a-PSG.pdf",
            },
            {
              label: "KIS factsheet 4 – How to apply for KIS",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-factsheet-4-How-to-apply-for-KIS.pdf",
            },
          ]}
        />{" "}
        <ResourcesLinks
          mainIcon="resource-icon-spec icon-spec kid-bag"
          links={[
            {
              label: "Signing up to the KIS portal video",
              url: "https://vimeo.com/1123749838",
              headerResources: "KIS portal user guides",
            },
            {
              label: "Screening questions and application creation video",
              url: "https://vimeo.com/1123763891",
            },
            {
              label: "Completing sections 3 – 8 of the online application video",
              url: "https://vimeo.com/1123764099",
            },
            {
              label: "Completing section 9, uploading documents and submitting video",
              url: "https://vimeo.com/1123764328",
            },
            {
              label: "KIS portal introduction video",
              url: "https://vimeo.com/1109207246?share=copy#t=0",
            },
            {
              label: "Kindergarten KIS portal user guide",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/Kindergarten-KIS-portal-user-guide.pdf",
            },
            {
              label: "KIS provider KIS portal user guide",
              url: "http://ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-provider-KIS-portal-user-guide.pdf",
            },
          ]}
        />
        <ResourcesLinks
          mainIcon="resource-icon-spec icon-spec cup"
          links={[
            {
              label: "Tips for completing KIS applications",
              url: "http://ahaconsulting.com.au/wp-content/uploads/2025/08/Tips-for-completing-KIS-applications.pdf",

              headerResources: "Tips and checklists",
            },
            {
              label: "Application completion checklist",
              url: "https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/Application-completion-checklist.pdf",
              padding: "pb-25",
            },
          ]}
        />
      </div>
    </>
  );
};

export default ResourcesLinksPage;
